/**
 * Derive a display-friendly set code for One Piece cards from the stored
 * combo-group setCode.
 *
 * TCGCSV bundles related sub-sets into combo groups whose setCode is a
 * multi-prefix string (`OP15-EB04`, `OP13 ANN`). OP players recognise the
 * first chunk as "the set" — so we splice it out for display:
 *
 *   - "OP15-EB04" → "OP15"
 *   - "OP13 ANN"  → "OP13"
 *   - "OP15"      → "OP15"  (already a single-prefix group)
 *   - "OP-PR"     → "P"     (promo umbrella; Bandai prints these under "P")
 *
 * Returns the input unchanged when nothing splices off.
 */
export function getOnePieceDisplaySetCode(setCode: string): string {
  if (!setCode) return setCode;
  if (setCode === "OP-PR") return "P";
  const sepIdx = setCode.search(/[-\s]/);
  return sepIdx === -1 ? setCode : setCode.slice(0, sepIdx);
}
